import { render, staticRenderFns } from "./MovingSubjects.vue?vue&type=template&id=8df8f7ba&"
import script from "./MovingSubjects.vue?vue&type=script&lang=js&"
export * from "./MovingSubjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports